
// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();




export const getTerminalsService = async() => {
   
    try {
        
        return await http.get<any>('/v1/employee-terminal'); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getTerminalsService ',error);

    }
}

export const createTerminalService = async(area:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/employee-terminal', area, setPercentajeCCompany); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createTerminalService ',error);

    }
}



export const getTerminalDetailService = async(terminalId:string) => {
   
    try {

        return await http.get<any>(`/v1/employee-terminal/${terminalId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getTerminalDetailService ',error);

    }
}


export const updateTerminalDetailService = async(terminal: object) => {
   
    try {

        return await http.put<any>(`/v1/employee-terminal`, terminal); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('updateTerminalDetailService ',error);

    }
}




export const desactiveTerminalService = async(terminalId: string) => {
   
    try {

        return await http.delete<any>(`/v1/employee-terminal/${terminalId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveTerminalService ',error);

    }
}



export const activeTerminalService = async(terminalId: string) => {
   
    try {

        return await http.patch<any>(`/v1/employee-terminal/${terminalId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeTerminalService ',error);

    }
}



export const getTerminalsByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/employee-terminal?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getTerminalsByPaginateService ',error)
    }
}